import { render } from "./homeResourceCentre.vue?vue&type=template&id=84efc686&scoped=true"
import script from "./homeResourceCentre.vue?vue&type=script&lang=js"
export * from "./homeResourceCentre.vue?vue&type=script&lang=js"

import "./homeResourceCentre.vue?vue&type=style&index=0&id=84efc686&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84efc686"]])

export default __exports__